// **PRODUCAO */

   export const basePath = "https://apiadmverdemar.fikdigital.com.br"

// *DESENVOLVIMENTO
// export const basePath = "https://localhost:44327";

// Api Prod
// export const basePath = "https://apiadmverdemar.fikdigital.com.br"
const service = "api";
const version = "v1";
export const vacancyApi = `${basePath}/${service}/${version}/Vaga/Filtrar`;
export const vacancyShowApi = `${basePath}/${service}/${version}/Vaga`;
export const vacancySearchApi = `${basePath}/${service}/${version}/Vaga/Buscar`;
export const PUBLISH_VACANCY = id => `${basePath}/${service}/${version}/Vaga/Publicar/${id}`;
export const DELETE_VACANCY = `${basePath}/${service}/${version}/Vaga`;

export const roleListApi = `${basePath}/${service}/${version}/Cargo/ListarTodosComPaginacao`;

export const dashboardUrls = {
  vacancy: `${basePath}/${service}/${version}/Dashboard/Vagas`,
  candidates: `${basePath}/${service}/${version}/Dashboard/Candidatos`,
  talents: `${basePath}/${service}/${version}/Dashboard/BancoTalentos`,
  documents: `${basePath}/${service}/${version}/Dashboard/Documento`,
  contracts: `${basePath}/${service}/${version}/Dashboard/Contratos`,
}

export const formInputFilliate = `${basePath}/${service}/${version}/CentroResultado/ListarTodosDaColigada`;
export const formInputAutoComplete = `${basePath}/${service}/${version}/funcionario/FiltrarFuncionarioPorNomeOuMatricula`;

export const login = `${basePath}/${service}/${version}/Login`;
// inputs end points
export const formInputsUrls = {
  areaFormation: `${basePath}/${service}/${version}/AreaFormacao`,
  eligibleJobs: `${basePath}/${service}/${version}/Cargo`,
  resultCenter: `${basePath}/${service}/${version}/CentroResultado`,
  city: `${basePath}/${service}/${version}/Cidade/ListarCidadesDasUnidadesDeTrabalho`,
  affiliate: `${basePath}/${service}/${version}/Coligada`,
  tecnicKnowledge: `${basePath}/${service}/${version}/ConhecimentoTecnico`,
  jobsByProfiles: `${basePath}/${service}/${version}/cargo/ListarComPerfil`,
  state: `${basePath}/${service}/${version}/Estado`,
  employee: `${basePath}/${service}/${version}/Funcionario`,
  jorney: `${basePath}/${service}/${version}/Jornada`,
  placeOfWork: `${basePath}/${service}/${version}/LocalUnidade/ListarTodosTipoLocalTrabalho`,
  level: `${basePath}/${service}/${version}/Nivel`,
  country: `${basePath}/${service}/${version}/Pais`,
  section: `${basePath}/${service}/${version}/Secao`,
  taker: `${basePath}/${service}/${version}/Tomador`,
  area: `${basePath}/${service}/${version}/Area`,
  schooling: `${basePath}/${service}/${version}/Vaga/InformacoesParaTela`,
  managerName: `${basePath}/${service}/${version}/Funcionario`,
  placeOfMedicExame: `${basePath}/${service}/${version}/LocalUnidade/ListarTodosTipoLocalExameMedico`,
  vacancyGroup: `${basePath}/${service}/${version}/GrupoVaga`,
  administrator: `${basePath}/${service}/${version}/Administrador/ListarTodos`,
};

export const stageCreateApi = `${basePath}/${service}/${version}/Etapa`;
export const getStageShowApi = `${basePath}/${service}/${version}/Etapa/RecuperarEtapaPorId`;
export const getStagesFilter = `${basePath}/${service}/${version}/Etapa/RecuperarEtapasParaAssociarTrilha`;
export const FINISH_ESTAGE_TO_USE = `${basePath}/${service}/${version}/Etapa/FinalizarCadastroEtapa`;
export const DELETE_STAGE_QUESTION_BLOCK = `${basePath}/${service}/${version}/Etapa/DeletarPerguntasDoTipoBloco`;

export const PERFORMACE_INDICATOR = `${basePath}/${service}/${version}/IndicadorPerformance`;

export const CREATE_RAILS = `${basePath}/${service}/${version}/Trilha`;
export const EDIT_RAILS = `${basePath}/${service}/${version}/Trilha/Editar`;
export const ADD_STAGE_TO_RAILS = `${basePath}/${service}/${version}/Trilha/AdicionarEtapa`;
export const GET_LIST_RAILS = `${basePath}/${service}/${version}/Trilha/RecuperarTodasSimplificadas`;
export const SHOW_LIST_RAILS = `${basePath}/${service}/${version}/Trilha/RecuperarPorId`;
export const GET_RAILS_TO_ASSOCIATE = `${basePath}/${service}/${version}/Trilha/RecuperarParaAssociarComVaga`;
export const DISABLE_RAILS = `${basePath}/${service}/${version}/Trilha/AlterarStatusTrilha`;
export const REMOVE_STAGE_FROM_RAILS = `${basePath}/${service}/${version}/trilha/RemoverEtapaTrilha`;
export const REQUEST_JOBS_FROM_AREA = `${basePath}/${service}/${version}/cargo/ListarTodosDaArea`;
export const REQUEST_ASSOCIATION_WITH_RAILS = `${basePath}/${service}/${version}/vaga/AssociarComTrilha`;
export const questionCreateApi = `${basePath}/${service}/${version}/Etapa/AdicionarPergunta`;
export const questionRegisterPositionToStage = `${basePath}/${service}/${version}/Etapa/AssociarCargos`;
export const questionRegisterToStage = `${basePath}/${service}/${version}/Etapa/AdicionarPergunta`;
export const QUESTION_UPDATE = `${basePath}/${service}/${version}/Etapa/EditarPergunta`;
export const QUESTION_DELETE = `${basePath}/${service}/${version}/Etapa/DeletarPergunta`;
export const EDIT_ASSOCIATION_ATTRIBUTES = `${basePath}/${service}/${version}/vaga/EditarAssociacaoTrilhaVaga`;
export const REQUEST_CANDIDATES_BANK_OF_TALENTS = `${basePath}/${service}/${version}/BancoTalentos/BuscarCandidatos`;
export const REQUEST_CHANGE_STATUS_CANDIDATES_BANK_OF_TALENTS = `${basePath}/${service}/${version}/BancoTalentos/AlterarStatus`;

export const stageListUrls = {
  baseInfos: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasDadosCadastrais`,
  tests: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasTestes`,
  trainner: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasTreinamento`,
  assay: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasAnalise`,
  medicExame: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasExameMedico`,
  admission: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasAdmissao`,
  feedback: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasFeedback`,
  ambientation: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasAmbientacao`,
  preAdmition: `${basePath}/${service}/${version}/Etapa/RecuperarEtapasPreAdmissao`
};

export const stageCreateInfosUrls = {
  testeInfo: `${basePath}/${service}/${version}/Etapa/InformacoesParaTelaEtapaTeste`,
  assayInfo: `${basePath}/${service}/${version}/Etapa/InformacoesParaTelaEtapaAnalise`,
  ambientationInfo: `${basePath}/${service}/${version}/Etapa/InformacoesParaTelaEtapaAmbientacao`,
  medicExameInfo: `${basePath}/${service}/${version}/Etapa/InformacoesParaTelaEtapaExameMedico`,
  trainnerInfo: `${basePath}/${service}/${version}/Etapa/InformacoesParaTelaEtapaTreinamento`
};

export const VANCANCY_CANDIDATES = `${basePath}/${service}/${version}/GerenciarCandidatos/ListarTodasVagasSimplificadas`;
export const CANDIDATES_FROM_VANCANCY = `${basePath}/${service}/${version}/GerenciarCandidatos/RecuperarVagaPorId`;
export const CANDIDATES_BY_NAME = `${basePath}/${service}/${version}/Candidato/FiltrarPorNome`;
export const CANDIDATES_ACTION = `${basePath}/${service}/${version}/GerenciarCandidatos/ExecutarAcaoNosCandidatos`;
export const CANDIDATE_SHOW = `${basePath}/${service}/${version}/GerenciarCandidatos/RecuperarCandidatoNaVagaPorIds`;
export const EXPORT_CANDIDATES = `${basePath}/${service}/${version}/GerenciarCandidatos/ExportarCandidatos`;
export const EMPLOYEE_BY_REGISTER_NUMBER = `${basePath}/${service}/${version}/Funcionario/RecuperarPorMatricula`;
export const ADD_CANDIDATE = `${basePath}/${service}/${version}/Vaga/AdicionarCandidatoNaVaga`;
export const EXPORT_PERSONAL_INFORMATION = `${basePath}/${service}/${version}/Candidato/ExportarDadosPessoaisCSV`;
export const RELEASE_PASSWORD_RESET = `${basePath}/${service}/${version}/Candidato/ResetarSenhaCandidato`;

export const REQUEST_PROFILES = `${basePath}/${service}/${version}/PerfilAcesso`;
export const REQUEST_PROFILEPERMISSIONS = `${basePath}/${service}/${version}/PerfilAcesso/ListaPermissoesDoPerfil`;
export const REQUEST_USERS = `${basePath}/${service}/${version}/PerfilAcesso/ListaUsuariosAdminAtivos`;
export const UPDATE_PERFIL_USERS = `${basePath}/${service}/${version}/PerfilAcesso/EditaPerfilUsuario`;
export const UPDATE_PERFIL_JOBS = `${basePath}/${service}/${version}/PerfilAcesso/EditaCargosDoPerfil`;
export const CREATE_PROFILES = `${basePath}/${service}/${version}/PerfilAcesso/CriarPerfil`;
export const GET_PERFIL_JOBS = `${basePath}/${service}/${version}/cargo/ListarComPerfil`;


export const EDIT_PERMISSIONS_PROFILES = `${basePath}/${service}/${version}/PerfilAcesso/EditaPermissoesDoPerfil`;

export const EDIT_ACCESS_STAGE_PROFILES = `${basePath}/${service}/${version}/PerfilAcesso/EditaAcessoEtapasPerfil`;




export const BANNER_ASSOCIATION = `${basePath}/${service}/${version}/Vaga/AssociarBannerAVaga`;
export const VANCANCY_PREVIEW_REQUEST = id =>
  `${basePath}/${service}/${version}/Vaga/VagaParaPreview/${id}`;


// PLUG --------------------------------------------------------------------------------------------------------
export const REQUEST_CANDIDATESVACANCY_DOCS = `${basePath}/${service}/${version}/Documentos/BuscarCandidatosDaVaga`;
export const REQUEST_CANDIDATES_FILES = `${basePath}/${service}/${version}/Documentos/RecuperaArquivosCandidatoEtapa`;
export const SET_CANDIDATES_FILES = `${basePath}/${service}/${version}/Documentos/AlteraStatusDocumento`;
export const DOCUMENTS_CONFIRM_STAGE = `${basePath}/${service}/${version}/Documentos/ConfirmaEtapaEnvioDocumentos`;
export const SET_DOCUMENT_CANDIDATE = `${basePath}/${service}/${version}/Documentos/RegistraNovoDocumentoCandidato`;
export const RELEASE_STAGE_FOR_CANDIDATES = `${basePath}/${service}/${version}/Documentos/LiberarEtapaDocumentos`;
export const RELEASE_CANCELLATION_FOR_CANDIDATES = `${basePath}/${service}/${version}/Documentos/CancelarEtapaDocumentos`;
export const GET_DOCUMENT_FILE = `${basePath}/${service}/${version}/Documentos/ExportarDocumentoCandidato`;

//REQUEST DUVIDAS
export const REQUEST_CANDIDATES_DOUBTS = `${basePath}/${service}/${version}/EnvioEmailRecrutador/ListarDuvidasCandidato`;
export const REQUEST_CANDIDATES_ANSWERS = `${basePath}/${service}/${version}/EnvioEmailRecrutador/SalvarRespostaDuvidas`;

export const REQUEST_CANDIDATES_VACANCY_CONTRACT = `${basePath}/${service}/${version}/Contrato/BuscarCandidatosDaVaga`;
export const REQUEST_TYPES_CONTRACT = `${basePath}/${service}/${version}/Contrato/BuscarTiposOpcaoContrato`;
export const REQUEST_CANDIDATES_CONTRACT_FILES = `${basePath}/${service}/${version}/Contrato/RecuperaContratosCandidatoEtapa`;
export const SET_CANDIDATES_CONTRACT_STATUS = `${basePath}/${service}/${version}/Contrato/AlteraStatusContrato`;
export const SET_CANDIDATES_NEWCONTRACT = `${basePath}/${service}/${version}/Contrato/AlteraStatusContrato`;
export const CONTRACT_CONFIRM_STAGE = `${basePath}/${service}/${version}/Contrato/ConfirmaEtapaEnvioContrato`;
export const CHANCE_CONTRACT_WITH_ERROR = `${basePath}/${service}/${version}/Contrato/AlteraStatusContratoComAlteracaoContrato`;



export const SET_NEW_CONTRACT = `${basePath}/${service}/${version}/Contrato/RegistraNovoContratoCandidato`;
export const CHANGE_CONTRACT = `${basePath}/${service}/${version}/Contrato/AtualizarContrato`;

export const CHANGE_KIT_CONTRACT = `${basePath}/${service}/${version}/Contrato/AlterarKit`;


// MANAGER
export const CREATE_MANAGER = `${basePath}/${service}/${version}/Administrador/`;
export const CHANGE_PASSWORD_MANAGER = `${basePath}/${service}/${version}/Administrador/AlterarSenha`;
export const CHANGE_ACESS_PLUG_MANAGER = `${basePath}/${service}/${version}/Administrador/AlteraPodeAcessarPlug`;
export const CHANGE_ACESS_TALENTOS_MANAGER = `${basePath}/${service}/${version}/Administrador/AlteraPodeAcessarTalentos`;
export const CHANGE_ACESS_USER_MANAGER = `${basePath}/${service}/${version}/Administrador/AlteraPodeEditarPerfil`;
export const DELETE_MANAGER = `${basePath}/${service}/${version}/Administrador/Deletar`;

